var br = function(elements) {
	var els = [];
	var _this = this;
	if (elements) {
		if (typeof elements == 'string') els = Array.prototype.slice.call(document.querySelectorAll(elements), 0);
		else if (typeof elements == 'object' && typeof elements.length == 'undefined') {
			els.push(elements);
		} else {
			els = elements;
		};
	} else {
		elements = null;
	};
	
	function addClass(el, className) {
		if (el) {
			if (el.classList) el.classList.add(className);
			else el.className += ' ' + className;
		};
	};

	function removeClass(el, className) {
		if (el) {
			if (el.classList) el.classList.remove(className);
			else el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
		};	
	};

	function toggleClass(el, className) {
		if (el) {
			if (el.classList) el.classList.toggle(className);
			else {
				var classes = el.className.split(' ');
				var existingIndex = classes.indexOf(className);
				if (existingIndex >= 0) classes.splice(existingIndex, 1);
				else classes.push(className);
				el.className = classes.join(' ');
			};
		};
	};

	function closest(el, selector) {
		if (el) {
				while (el) { if (el.matches(selector)) { return el; }
				el = el.parentElement;
			};
		};
	};

	function fullHight(element) {
		if (element) {
			if (window.innerWidth > 768 && window.innerHeight > 620 || element.classList.contains('cover')) {
				element.style.height = window.innerHeight + 'px';
			} else {
				element.style.height = '';
			};
		};
	};

	var forEach = function(array, callback) {
		for (var i = 0; i < array.length; i++) {
			callback(array[i], i);
		};
	};

	function inputs() {
		forEach(document.querySelectorAll('input, select, textarea'), function(input) {
			if (input.type != 'hidden') {
				if (input.value !== '' || input.disabled) addClass(input,'filled');
				input.addEventListener('focus', function(el) {
					addClass(el.target,'filled');
				});
				input.addEventListener('focusout', function(el) {
					if (input.value == '' || input.disabled) removeClass(el.target,'filled');
				});
			};
		});
	};

	function slicArr() { return Function.prototype.call.apply(Array.prototype.slice, arguments); };
	function serialize(form){if(!form||form.nodeName!=="FORM"){return }var i,j,q=[];for(i=form.elements.length-1;i>=0;i=i-1){if(form.elements[i].name===""){continue}switch(form.elements[i].nodeName){case"INPUT":switch(form.elements[i].type){case"text":case"email":case"tel":case"number":case"hidden":case"password":case"button":case"reset":case"submit":q.push(form.elements[i].name+"="+encodeURIComponent(form.elements[i].value));break;case"checkbox":case"radio":if(form.elements[i].checked){q.push(form.elements[i].name+"="+encodeURIComponent(form.elements[i].value))}break;case"file":break}break;case"TEXTAREA":q.push(form.elements[i].name+"="+encodeURIComponent(form.elements[i].value));break;case"SELECT":switch(form.elements[i].type){case"select-one":q.push(form.elements[i].name+"="+encodeURIComponent(form.elements[i].value));break;case"select-multiple":for(j=form.elements[i].options.length-1;j>=0;j=j-1){if(form.elements[i].options[j].selected){q.push(form.elements[i].name+"="+encodeURIComponent(form.elements[i].options[j].value))}}break}break;case"BUTTON":switch(form.elements[i].type){case"reset":case"submit":case"button":q.push(form.elements[i].name+"="+encodeURIComponent(form.elements[i].value));break}break}}return q.join("&")};

	function ajaxSend(data, callback, before, link, document) {
		link = link || window.location;
		var xhr = new XMLHttpRequest();
		
		xhr.open('POST', link, true);
		xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		if (document) xhr.responseType = 'document';
		xhr.send(data);
		if (before) before();

		xhr.onreadystatechange = function() {
			if (this.readyState === 4 && this.status == 200 && callback) {
				var resp = this.response;
				if (typeof resp === 'string') {
					resp = JSON.parse(resp);
				};
				callback(resp);
			};
		};
	};

	function fetch(link, callback) {
		link = link || window.location;
		var xhr = new XMLHttpRequest();
		xhr.responseType = 'json';
		xhr.open('GET', link, true);
		xhr.onreadystatechange = function() {
			if (this.readyState === 4 && this.status == 200 && callback) {
				var resp = this.response;
				if (typeof resp === 'string') {
					resp = JSON.parse(resp);
				};
				callback(resp);
			};
		};
		xhr.send();
	};

	function fetchSvg(el, url) {
		var xhr = new XMLHttpRequest();
		
		xhr.open('GET', url, true);
		xhr.responseType = 'text';
		xhr.send();

		xhr.onreadystatechange = function() {
			if (this.readyState === 4 && this.status == 200) {
				el.innerHTML = this.response;
			};
		};
	};

	function ajaxForm(form, callbefore, callafter, doc, honey) {
		doc = doc || false;

		function send(form, callbefore, callafter, doc) {
			if (callbefore) callbefore(form);
			ajaxSend(serialize(form), function(response) {
				if (callafter) callafter(response, form);
				form.reset();
				forEach(form.elements, function(el) {
					removeClass(el,'filled');
					el.blur();
				});
			}, false, false, doc);
		};
		if (form) {
			form.addEventListener('submit', function(event) {
				event.preventDefault(); event.stopPropagation();
				if (honey) {
					if (honey.value == 0) send(form, callbefore, callafter, doc);
					else console.error('honey is filled');
				} else send(form, callbefore, callafter, doc);
			});
		};
	};

	function reFetch(what, link, fn) {
		link = link || window.location;
		var xhr = new XMLHttpRequest();
		xhr.open('GET', link);
		xhr.responseType = 'document';
		xhr.send();

		xhr.onload = function() {
			if (this.status !== 200) console.log(this.response)
			else {
				var oldDoc = qOne(what),
					newDoc = this.response.querySelector(what);
				if (oldDoc && newDoc) oldDoc.innerHTML = newDoc.innerHTML;
				if (fn) fn(this.response);
			};
		};
	};

	function fetchEl(link, what, fn) {
		var xhr = new XMLHttpRequest();
		xhr.open('GET', link);
		xhr.responseType = 'document';
		xhr.send();

		xhr.onload = function() {
			if (this.status !== 200) console.log(this.response)
			else {
				var newDoc = this.response.querySelector(what);
				fn(newDoc);
			};
		};
	};

	function closest(el, selector) {
		while (el) { if (el.matches(selector)) { return el; }
			el = el.parentElement;
		};
	};

	function getScrollbarWidth() {
		var outer = document.createElement("div");
		outer.style.visibility = "hidden";
		outer.style.width = "100px";
		document.body.appendChild(outer);
		var widthNoScroll = outer.offsetWidth;
		outer.style.overflow = "scroll";
		var inner = document.createElement("div");
		inner.style.width = "100%";
		inner.style.opacity = 0;
		outer.appendChild(inner);        
		var widthWithScroll = inner.offsetWidth;
		outer.parentNode.removeChild(outer);
		return widthNoScroll - widthWithScroll;
	};

	function loadScript(url, completeCallback) {
		var script = document.createElement('script'), done = false,
			head = document.getElementsByTagName("head")[0];
		script.src = url;
		script.onload = script.onreadystatechange = function(){
			 if ( !done && (!this.readyState ||
						this.readyState == "loaded" || this.readyState == "complete") ) {
				done = true;
				if (completeCallback) completeCallback();

				script.onload = script.onreadystatechange = null;
				head.removeChild( script );
			}
		};
		head.appendChild(script);
	};

	function JSrun(cont) {
		var newJs = cont.querySelectorAll('script'),
		head = document.querySelector('head'),
		oldJs = Array.from(document.querySelectorAll('script'));
		forEach(newJs, function(el) {
			var checked = oldJs.filter(function(js) {
				if (js.isEqualNode(el)) {
					js.remove(); 
					return js.isEqualNode(el);
				} else return 'done';
			}).length > 0;
			if(checked){
				var script = document.createElement('script');
				forEach(el.attributes, function(attr) {
					if (attr.specified) {
						script.setAttribute(attr.name, attr.value);
					};
				});
				script.innerHTML += el.innerHTML;
				head.appendChild(script);
			};
		});
	};

	function scrollTo(el, target) {
		var tar = document.querySelector(target);
		if (TweenLite && tar) {
			el.addEventListener('click', function(click) {
				var elpos = tar.getBoundingClientRect().top + window.scrollY;
				var clickPos = click.target.getBoundingClientRect().top + window.scrollY;
				var speed = Math.abs(clickPos-elpos) < 1000 ? 1 : Math.abs(clickPos-elpos) < 2000 ? 2 : 3;
				TweenLite.to(window, speed, { 
					scrollTo: {
						y:elpos, 
						autoKill:false,
					}, ease:Power2.easeInOut
				});
			});
		};
	};

	function hasClass(el, className) {
		return el.classList.contains(className);
	};

	return {
		$: els.length == 0 ? false : els,
		first: els ? els[0] : false,
		length: els ? els.length : 0,

		//for nodelist
		click: 		function(callback)  { forEach(els, function(el, i) { el.addEventListener('click', 	 function(event) { callback(event, el, i); }); }); return this; },
		scroll: 	function(callback)  { forEach(els, function(el, i) { el.addEventListener('scroll', 	 function(event) { callback(event, el, i); }); }); return this; },
		resize: 	function(callback)  { forEach(els, function(el, i) { el.addEventListener('resize', 	 function(event) { callback(event, el, i); }); }); return this; },
		hoverOut: 	function(callback)  { forEach(els, function(el, i) { el.addEventListener('mouseout', function(event) { callback(event, i, el); }); }); return this; },
		hover: 		function(callback)  { forEach(els, function(el, i) { el.addEventListener('mouseover',function(event) { callback(event, el, i); }); }); return this; },
		submit: 	function(callback)  { forEach(els, function(el, i) { el.addEventListener('submit', 	 function(event) { callback(event, el, i); }); }); return this; },
		change: 	function(callback)  { forEach(els, function(el, i) { el.addEventListener('change', 	 function(event) { callback(event, el, i); }); }); return this; },
		keyup: 		function(callback)  { forEach(els, function(el, i) { el.addEventListener('keyup',  	 function(event) { callback(event, el, i); }); }); return this; },
		addCls: 	function(className) { forEach(els, function(el, i) { addClass(el, className)			 										   }); return this; },
		rmCls: 		function(className) { forEach(els, function(el, i) { removeClass(el, className)		 											   }); return this; },
		toCls: 		function(className) { forEach(els, function(el, i) { toggleClass(el, className) 		 										   }); return this; },
		for: 		function(callback)  { forEach(els, function(el, i) { callback(el, i); 				 											   }); return this; },
		append: 	function(what)   	{ forEach(els, function(el, i) { el.appendChild(what); 			 											   }); return this; },
		fullHight:  function() 			{ forEach(els, function(el, i) { fullHight(el); 					 										   }); return this; },
		scrollTo:   function(target) 	{ forEach(els, function(el, i) { scrollTo(el, target); 					 								 	   }); return this; },
		fetchSvg: 	function()			{ forEach(els, function(el, i) { fetchSvg(el, el.dataset.svgUrl); 											   }); return this; },

		//for one el
		ajaxForm: 	function(f1,f2,d,h)	{ ajaxForm(els[0], f1, f2, d, h); return this },
		serialize:  function()			{ return serialize(els[0]) },
		hasClass: 	function(cN)		{ return hasClass(els[0], cN); },
		closest: 	function(selector)	{ return closest(els[0], selector) },
		addCl: 		function(className) { addClass(els[0], className); return this; },
		rmCl: 		function(className) { removeClass(els[0], className); return this; },
		toCl: 		function(className) { toggleClass(els[0], className); return this; },
		
		//utilities
		ajaxSend: 	function(d,f1,f2,u)	{ ajaxSend(d, f1, f2, u); },
		fetchEl: 	function(l, w, f)	{ fetchEl(l, w, f) },
		fetch: 		function(link, f)	{ fetch(link, f) },
		JSrun: 		function(cont)		{ JSrun(cont) },
		scrollbar:  function()          { return getScrollbarWidth() },
		inputs: 	function() 			{ inputs() },
		loadScript: function(l,f)		{ loadScript(l,f) },
	};
};

export { br }


// WEBPACK FOOTER //
// ./__dev/js/bruQuery.js